import { Injectable } from "@angular/core";
import { BfxBaseBlotterFilteringService } from "../bfx-base-blotter/bfx-base-blotter-filtering.service";
import {
  OrdersTableDefinitionFactory,
  ActiveUserProfilePromiseService,
  ClientPromiseLookupService,
  CcyPairPromiseLookupService,
  CurrencyPairGroupPromiseLookupService,
  ColumnFilterType,
  AlgoStrategyLookupService,
  AlgoStrategyPromiseLookupService,
} from "shared/cubiq-services";
import { BfxSysConfigUtilService } from "shared/auth-services";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { BfxColDef } from "shared/cubiq-services/model/TableDefinition";
import {
  QueryRuleImpl,
  RequestOrderType,
  AlgoStrategyImpl,
  OrderType,
  OrderDataImpl,
} from "shared/cubiq-model-multi-asset";

@Injectable()
export class BfxOrderBlotterFilteringService extends BfxBaseBlotterFilteringService {
  /** Set of all tradable algo descriptions (desc used in Filter defns) */
  private tradableAlgoDescriptions: Set<string> = new Set();

  constructor(
    protected tableDefinitionFactory: OrdersTableDefinitionFactory,
    protected activeUserService: ActiveUserProfilePromiseService,
    protected clientService: ClientPromiseLookupService,
    protected currencyPairService: CcyPairPromiseLookupService,
    protected currencyPairGroupService: CurrencyPairGroupPromiseLookupService,
    protected algoStrategyLookup: AlgoStrategyPromiseLookupService,
    protected sysConfigUtilService: BfxSysConfigUtilService,
  ) {
    super(
      tableDefinitionFactory,
      activeUserService,
      clientService,
      currencyPairService,
      currencyPairGroupService,
    );

    Promise.all([activeUserService.getActiveUserData(), algoStrategyLookup.isPrimed()]).then(
      ([activeUser, _primed]) => {
        activeUser.tradableAlgos.forEach((algoId) => {
          this.algoStrategyLookup.getAlgoStrategy(algoId).then((algoStrategy: AlgoStrategyImpl) => {
            if (algoStrategy) {
              this.tradableAlgoDescriptions.add(algoStrategy.description);
            } else {
              logger.out.warn(
                `Cannot find tradable algo for id '${algoId}', removing from filter order type list`,
              );
            }
          });
        });
      },
    );
  }

  protected preprocessValues(column: BfxColDef, rule: QueryRuleImpl): Array<any> {
    let values: Array<any> = rule.values;

    switch (column.columnFilterType) {
      case ColumnFilterType.ORDERTYPE:
        const initValue: string[] = [];
        values = rule.values.reduce((result: string[], value: string) => {
          let val: any = RequestOrderType[value];
          if (val != null) {
            const orderStr = this.tableDefinitionFactory.myOrderTypeHelper.getValue(
              {
                [this.tableDefinitionFactory.myOrderTypeHelper.getColumnProperty()]: val,
              },
              false,
            );
            result.push(orderStr);
          } else {
            if (this.tradableAlgoDescriptions.has(value)) {
              result.push(value);
            }
          }
          return result;
        }, initValue);
        break;
      default:
        values = super.preprocessValues(column, rule);
        break;
    }
    return values;
  }
}
